module.exports = __webpack_public_path__ + "img/joy.892922e5.svg";